import { Component } from '@angular/core';
export class AmdHeroComponent {
}
AmdHeroComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-hero',
                template: "<div class=\"amd-hero\"> <div class=\"amd-hero__background\"> <ng-content select=\"[amdHeroBackground]\"></ng-content> </div> <div class=\"amd-hero__content\"> <ng-content select=\"[amdHeroContent]\"></ng-content> </div> </div>"
            },] },
];
/**
 * @nocollapse
 */
AmdHeroComponent.ctorParameters = () => [];
function AmdHeroComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdHeroComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdHeroComponent.ctorParameters;
}
//# sourceMappingURL=hero.component.js.map
//# sourceMappingURL=hero.component.js.map
